import React, { useState } from 'react';
import { Button, message } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import { createStyles } from 'antd-style';
import { bindOrderQr } from '@/services/ant-design-pro/cp';

const useStyles = createStyles(({ token }) => ({
    quickReplyContainer: {
        padding: '12px 16px 0',
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        backgroundColor: token.colorBgContainer,
    },
    quickReplyTitle: {
        fontSize: '12px',
        color: token.colorTextSecondary,
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    quickReplyList: {
        display: 'flex',
        gap: '8px',
        overflowX: 'auto',
        paddingBottom: '4px',
        '&::-webkit-scrollbar': {
            height: '4px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '2px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '2px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#a1a1a1',
        },
    },
    quickReplyButton: {
        fontSize: '12px',
        height: '28px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
}));

interface QrItem {
    id: bigint | string;
    name?: string | null;
    payment_method: string;
    receiver_name?: string | null;
}

interface QuickReplyProps {
    qrList: QrItem[];
    connected: boolean;
    orderNo: string;
    onQuickReply: (qr: QrItem) => void;
}

export const QuickReply: React.FC<QuickReplyProps> = ({ qrList, connected, orderNo, onQuickReply }) => {
    const { styles } = useStyles();
    const [bindingQrId, setBindingQrId] = useState<string>('');

    // 处理二维码点击
    const handleQrClick = async (qr: QrItem) => {
        if (!connected) {
            message.warning('连接已断开，无法绑定二维码');
            return;
        }

        setBindingQrId(String(qr.id));
        try {
            const response = await bindOrderQr({
                order_no: orderNo,
                qr_id: String(qr.id),
            });

            if (response.code === 0) {
                message.success('二维码绑定订单成功');
                // 调用原来的回调
                onQuickReply(qr);
            } else {
                message.error(response.msg || '绑定二维码到订单失败');
            }
        } catch (error) {
            console.error('绑定二维码失败:', error);
            message.error('绑定二维码到订单失败');
        } finally {
            setBindingQrId('');
        }
    };

    if (qrList.length === 0) {
        return null;
    }

    return (
        <div className={styles.quickReplyContainer}>
            <div className={styles.quickReplyTitle}>
                <QrcodeOutlined />
                快捷回复 - 二维码列表
            </div>
            <div className={styles.quickReplyList}>
                {qrList.map((qr) => (
                    <Button
                        key={qr.id.toString()}
                        size="small"
                        className={styles.quickReplyButton}
                        disabled={!connected || bindingQrId !== ''}
                        loading={bindingQrId === String(qr.id)}
                        onClick={() => handleQrClick(qr)}
                    >
                        {`${qr.payment_method}-${qr.name}`}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export type { QrItem }; 